<template>
  <div class="task-detail">
    <div class="task-detail-header">
      <h3 class="task-detail-title">任务详情</h3>
      <div class="task-detail-info">
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-refresh"
          @click="handleRefresh"
          >刷新数据</el-button
        >
        <el-tag
          class="status-tag"
          type="primary"
          effect="plain"
          size="medium"
          >{{ taskInfo.taskStateName }}</el-tag
        >
        <div class="info-item">任务单号：{{ taskInfo.taskNo }}</div>
        <div class="info-item">创建人：{{ taskInfo.createName }}</div>
        <div class="info-item">创建时间：{{ taskInfo.createTime }}</div>
      </div>
    </div>

    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter" class="search-form">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="员工ID">
            <el-input
              v-model="searchForm.staffId"
              placeholder="请输入员工ID查询"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item label="所在门店">
            <el-select
              v-model="searchForm.storeId"
              filterable
              clearable
              placeholder="请选择或输入门店"
              size="small"
            >
              <el-option
                v-for="item in storeList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              v-model="searchForm.staffName"
              placeholder="请输入姓名查询"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              v-model="searchForm.staffMobile"
              placeholder="请输入手机号查询"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleSearch"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <div class="detail-content">
        <div
          style="display: flex;align-items: center;justify-content: space-between;"
        >
          <div class="detail-tabs">
            <div
              v-for="item in tabList"
              :key="item.value"
              :class="['detail-tab', tabValue === item.value ? 'active' : '']"
              @click="handleTabClick(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
          <el-button
            size="small"
            type="success"
            icon="el-icon-download"
            :loading="exportLoading"
            @click="handleExportExcel"
            >导出Excel</el-button
          >
        </div>

        <GlobalTable
          v-if="refresh"
          ref="detailTable"
          v-loading="loading"
          :columns="tableColumns"
          :data="detailList"
          :currentPage="page.pageNum"
          :total="page.total"
          @handleCurrentChange="handleCurrentChange"
        >
          <el-table-column label="发放绩效" slot="amount" align="center">
            <template slot-scope="{ row }">
              <span>{{ (row.amount || 0) + "元" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所在门店" slot="storeName" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.storeName || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发放时间" slot="execTime" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.execTime || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="流水单号" slot="taskSubNo" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.accountUniqNo || "--" }}</span>
            </template>
          </el-table-column>
        </GlobalTable>

        <div class="statistics">
          <span
            >合计导入数据：<b>{{ taskInfo.allNum || 0 }}</b
            >条</span
          >
          <span
            >合计发放金额：<b>{{ taskInfo.allAmount || 0 }}</b
            >元</span
          >
          <span
            >发放成功金额：<b>{{ taskInfo.finishAmount || 0 }}</b
            >元</span
          >
        </div>
      </div>
    </GlobalChunk>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { MessageBox } from "element-ui";
export default {
  name: "TaskDetail",
  data() {
    return {
      refresh: true,
      loading: false,
      taskInfo: {
        taskNo: "",
        createName: "",
        createTime: "",
        taskState: "",
        taskStateName: "",
        allNum: 0,
        allAmount: 0,
        finishNum: 0,
        finishAmount: 0,
      },
      stateCountMap: {},
      storeList: [],
      searchForm: {
        staffId: "",
        storeId: "",
        staffName: "",
        staffMobile: "",
      },
      tabValue: "",
      tabList: [],
      tableColumns: [
        { label: "序号", type: "index", width: "60px" },
        { label: "员工ID", prop: "staffId" },
        { label: "岗位", prop: "position" },
        { slotName: "storeName" },
        { label: "姓名", prop: "staffName" },
        { label: "手机号", prop: "staffMobile" },
        { slotName: "amount" },
        { slotName: "execTime" },
        { slotName: "taskSubNo" },
      ],
      detailList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      exportLoading: false,
      exportParams: {},
      state:"",
    };
  },
  created() {
    this.taskInfo.taskNo = this.$route.query.taskNo || "";
    this.state = this.$route.query.state || "";
    this.getStoreList();
    this.fetchDetailList();
  },
  methods: {
    getStoreList() {
      _api.getStoreSelectOrder().then((res) => {
        this.storeList = res.data || [];
      });
    },
    buildTabList() {
      const allCount =
        (this.stateCountMap["00"] || 0) +
        (this.stateCountMap["01"] || 0) +
        (this.stateCountMap["02"] || 0);
      this.tabList = [
        { label: "全部(" + (this.page.total || 0) + ")", value: "" },
        {
          label: "待发放(" + (this.stateCountMap["00"] || 0) + ")",
          value: "00",
        },
        {
          label: "发放成功(" + (this.stateCountMap["01"] || 0) + ")",
          value: "01",
        },
        {
          label: "发放失败(" + (this.stateCountMap["02"] || 0) + ")",
          value: "02",
        },
      ];
    },
    fetchDetailList() {
      this.refresh = false;
      this.loading = true;
      const params = {
        taskNo: this.taskInfo.taskNo,
        execState: this.tabValue,
        state:this.state,
        staffId: this.searchForm.staffId || "",
        storeId: this.searchForm.storeId || "",
        staffName: this.searchForm.staffName || "",
        staffMobile: this.searchForm.staffMobile || "",
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.exportParams = params;
      _api
        .getPerformanceTaskDetailPageList(params)
        .then((res) => {
          const data = res.data || {};
          const pageData = data.page || {};
          this.detailList = pageData.records || [];
          this.page.total = pageData.total || 0;
          this.page.pageNum = pageData.current || this.page.pageNum;
          this.taskInfo = {
            ...this.taskInfo,
            taskNo: data.taskNo || this.taskInfo.taskNo,
            createName: data.createName || "",
            createTime: data.createTime || "",
            taskState: data.taskState || "",
            taskStateName: data.taskStateName || "",
            allNum: data.allNum || 0,
            allAmount: data.allAmount || 0,
            finishNum: data.finishNum || 0,
            finishAmount: data.finishAmount || 0,
          };
          this.stateCountMap = data.stateCountMap || {};
          this.buildTabList();
        })
        .finally(() => {
          this.loading = false;
          this.refresh = true;
        });
    },
    handleExportExcel() {
      this.exportLoading = true;
      _api
        .exportPerformanceexportDetailExcel(this.exportParams)
        .then((res) => {
          console.log(res);
          const content = res;
          const blob = new Blob([content]);
          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg, "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              const fileName = "绩效发放任务明细.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },

    handleTabClick(val) {
      this.tabValue = val;
      this.page.pageNum = 1;
      this.fetchDetailList();
    },
    handleRefresh() {
      this.page.pageNum = 1;
      this.fetchDetailList();
    },
    handleSearch() {
      this.page.pageNum = 1;
      this.fetchDetailList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.fetchDetailList();
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
/deep/.global-chunk {
  background-color: #ffffff;
  border-radius: 20px 20px 0 0;
}
/deep/.global-chunk_header {
  padding-bottom: 20px;
  margin-bottom: 0px;
}
.task-detail {
  .task-detail-header {
    padding: 10px 20px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .task-detail-title {
      font-size: 18px;
      font-weight: 700;
      color: #242d3e;
      margin: 0;
      margin-right: 20px;
    }

    .task-detail-info {
      display: flex;
      align-items: center;
      gap: 20px;
      font-size: 14px;
      color: #666;

      .status-tag {
        border-radius: 15px 14px 14px 4px;
        margin: 0 8px;
      }

      .info-item {
        color: #0981ff;
      }
    }
  }

  .search-form {
    /deep/.el-form-item {
      margin-bottom: 0;
    }
  }

  .detail-content {
    position: relative;

    .detail-tabs {
      display: flex;
      background: #f9fbfd;
      border: 1px solid #c1d1ff;
      border-radius: 20px;
      width: fit-content;
      margin-bottom: 20px;
      overflow: hidden;

      .detail-tab {
        padding: 6px 16px;
        font-size: 14px;
        cursor: pointer;
        color: #333;

        &.active {
          background: #0981ff;
          color: #fff;
        }
      }
    }

    .statistics {
      margin-top: 20px;
      font-size: 14px;
      color: #666;

      span {
        margin-right: 40px;
      }

      b {
        color: #0981ff;
        margin: 0 4px;
      }
    }
  }
}
</style>
